<template>
<main>
    <div class="container margin_30">
        <div class="page_header">
            <div class="breadcrumbs">
                <ul>
                    <li>Refund and Cancellation Policy</li>
                </ul>
            </div>
            <h1>Refund and Cancellation Policy</h1>
        </div>
        
        <div class="content-container">
            <p>Last updated: April 4, 2025</p>
            <p>Thank you for choosing <strong>Edutech Institute</strong>.</p>
            <p>We strive to provide the best learning experience. However, if You are not satisfied with a course or subscription, this Refund and Cancellation Policy explains Your rights and options.</p>

            <h2>Interpretation and Definitions</h2>
            <h3>Definitions</h3>    
            <ul>
                <li><strong>Company</strong> (referred to as either “the Company”, “We”, “Us” or “Our” in this Agreement) refers to Edutech Institute.</li>
                <li><strong>Course</strong> refers to online learning content, modules, or training purchased on our platform.</li>
                <li><strong>Subscription</strong> refers to a paid plan that gives You access to multiple courses or premium features.</li>
                <li><strong>Service</strong> refers to the Edutech Institute platform.</li>
                <li><strong>You</strong> means the individual accessing or using the Service, as applicable.</li>
            </ul>

            <h2>Refund Policy</h2>
            <p><strong>NO REFUND POLICY:</strong> All payments made to <strong>Edutech Institute</strong> are <u>non-refundable</u>.  
            Once a course, subscription, or service is purchased, no cancellations or refunds will be provided under any circumstances.</p>

            <h2>Contact Us</h2>
            <p>If You have any questions about our Refund and Cancellation Policy, please contact us:</p>
            <ul>
                <li>By email: lms@dktechs.in</li>
            </ul>
        </div>
                         <router-link to="/" class="btn btn-primary mt-1 mb-1">
                                Go to Home
                                </router-link>
    </div>
</main>
</template>
